import _ from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import KycApplicationContext from "../../Context/KYCApplicationContext/KYCApplicationContext";
import { getIsKycProcessCompleted, getWidgetDTOList } from "../../Store/WidgetDataSelector";
import { WidgetEnum } from "../../Store/WidgetEnum";


function Workflow(props) {
  const applicationContext = useContext(KycApplicationContext);
  // maintain the current workflow object
  const [currentWorkflow, setCurrentWorkFlow] = useState({});
  const [currentWidget, setCurrentWidget] = useState({});
  const currentHolder = applicationContext.currentHolder;

  let widgetList = useSelector((state) =>
  getWidgetDTOList(
    state,
    currentHolder ? currentHolder.entityTypeShortName : ""
  )
);

let isKycProcessCompleted = useSelector((state) =>
getIsKycProcessCompleted(state));


  // workflowDisplayName active
  const isActive =(workflowDisplayName)=>{
    // classes should in snake Case
    return ' workflowbtn '+((currentWorkflow && workflowDisplayName === currentWorkflow.workflowDisplayName) ?' workflownameactive':'default');
  }

  // workflowname active
  const widgetOrderClass =(widgetObj)=>{
    // classes should in snake Case
    return  (widgetObj.status === "Completed")?'grntick':`sn_${widgetObj.displayIndex}`;
  }

// workflow active
  const isWorkFLowActive = (widget) => {
     return ' workflowlist '+ ((currentWidget && widget.widgetShortName === currentWidget.widgetShortName)?'workflowbtnactive': ((widget.status === "Completed")?'workflowbtncompleted':'default'));
  }


  // assign user selected workflow
  const assignWorkflow = (e, obj) => {
    e.preventDefault();
    setWorkflow(obj);    
  };

  const assignWidget = (e, obj) => {
    e.preventDefault();
    //setWidget(obj);
    props.onWidgetChange(obj, widgetList);
    
  };

  function setWorkflow(obj) {
    setCurrentWorkFlow(obj);
    applicationContext.setCurrentWorkflow(obj);
    //if cureent workflow has widget then assign the first widget as current widget
    if (obj && obj.widgetDTOList) {
      setWidget(getDefaultWidget(obj.widgetDTOList));
    }
  }

  function getDefaultWidget(widgetList) {
    let widget =null;
    const widgetShortName = applicationContext.widgetShortNameToShow;
    //if any widget configured in the context then show it otherwise set the fist widget a default widget
    if(widgetShortName && widgetShortName!==""){
      widget =_.find(widgetList,(widget)=>widget.widgetShortName===widgetShortName);
    }
    if(widget==null){
      widget= widgetList[0];
    }
    applicationContext.setWidgetShortNameToShow("");
    return widget;
  }

  function setWidget(obj) {
    setCurrentWidget(obj);
    applicationContext.setCurrentWidget(obj);
    //navigate(`/${obj.widgetUrl}`);
  }
  
  useEffect(() => {
    //select the default workflow on render 
    setWidget(applicationContext.currentWidget);
  }, [applicationContext.currentWidget]); 

  // set the default workflow based on the selected workflow
  function setDefaultWorkflow(){
    let count = 0;
    for(count = 0;count < props.model.length;count++){
      if(props.model[count].workflowDisplayName === props.selectedWorkflow){
        setWorkflow(props.model[count]);
        document.getElementById(props.model[count].workflowDisplayName + props.holder).disabled = false;
      }else{
        document.getElementById(props.model[count].workflowDisplayName + props.holder).disabled = true;
      }
    }
  }

  useEffect(() => {
    //select the default workflow on render
    if (props.model && props.model.length > 0) {
      setDefaultWorkflow();
    }
  }, [props.model]);


  const hanldeWidgetMenuDisable=(widgetObject)=>{
    let disabled = false;
    //is kyc process not completed yet then disable preview widget menu should be disabled.
    if(isKycProcessCompleted !=null && !isKycProcessCompleted 
        && widgetObject && 
        (widgetObject.widgetShortName===WidgetEnum.PVIEWCKYC || widgetObject.widgetShortName===WidgetEnum.ESIGNTC)){
      disabled= true;
    }

    return disabled;

  }


 
  return (
    <div>
      {/* Loop the workflow list and create workflow button for each */}
      <div className="mb-2">
        {props.model.map((obj) => {
          return (
          
              <button  className={isActive(obj.workflowDisplayName)}
                key={obj.workflowDisplayName}
                onClick={(event) => assignWorkflow(event, obj)}
                id={obj.workflowDisplayName + props.holder}>
                {obj.workflowDisplayName}
              </button>
             
          )}
          )}
        
      </div>
      {/* Loop the current workflow widget and print it */}
      <div className="workFlowListLayout">
        
        {currentWorkflow &&
          currentWorkflow.widgetDTOList &&
          currentWorkflow.widgetDTOList.sort((firstObj,secObj) => firstObj.displayIndex - secObj.displayIndex).map((obj,index) => {
            return (
            <button key={obj.displayIndex}  className={isWorkFLowActive(obj)} onClick={(e)=> assignWidget(e,obj)} 
            > 
            <span className={widgetOrderClass(obj)}></span> <span className="verticalaligntop ms-1">{obj.widgetName}</span></button> );
          })}
         {/*   <Outlet/> */}
      </div>
    </div>
  );

 
}

export default Workflow;

